<div>
  <!-- Mobile view -->
  <div class="flex flex-1 justify-between sm:hidden">
    <button
      type="button"
      (click)="onPageChange(pagination.current_page - 1)"
      [class.opacity-75]="pagination.current_page === 1"
      [disabled]="pagination.current_page === 1"
      class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
    >
      Previous
    </button>
    <button
      type="button"
      (click)="onPageChange(pagination.current_page + 1)"
      [class.opacity-75]="pagination.current_page === pagination.last_page"
      [disabled]="pagination.current_page === pagination.last_page"
      class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
    >
      Next
    </button>
  </div>

  <!-- Desktop view -->
  <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
    <!-- Left side: Results info and per page selector -->
    <div class="flex justify-start items-center space-x-3">
      <div class="hidden">
        <p class="text-sm text-gray-500 dark:text-primary-200">
          {{ "showing" | translate }}
          <span class="text-gray-700 dark:text-primary-200 font-medium">{{
            (pagination.current_page - 1) * pagination.per_page + 1
          }}</span>
          {{ "to" | translate }}
          <span class="text-gray-700 dark:text-primary-200 font-medium">{{
            pagination.current_page * pagination.per_page
          }}</span>
          {{ "of" | translate }}
          <span class="text-gray-700 dark:text-primary-200 font-medium">{{
            pagination.total
          }}</span>
          {{ "results" | translate }}
        </p>
      </div>
    </div>

    <!-- Right side: Navigation buttons -->
    <div>
      <nav
        class="isolate inline-flex -space-x-px rounded-md shadow-sm"
        aria-label="Pagination"
      >
        <button
          type="button"
          (click)="onPageChange(pagination.current_page - 1)"
          [disabled]="pagination.current_page === 1"
          class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 dark:text-primary-200 ring-1 ring-inset ring-gray-300 dark:ring-primary-200 hover:bg-gray-50 hover:dark:bg-transparent focus:z-20 focus:outline-offset-0"
        >
          <span class="sr-only">Previous</span>
          <svg
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
              clip-rule="evenodd"
            />
          </svg>
        </button>

        <button
          type="button"
          (click)="onPageChange(pagination.current_page + 1)"
          [disabled]="!hasNextPage"
          class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 dark:text-primary-200 ring-1 ring-inset ring-gray-300 dark:ring-primary-200 hover:bg-gray-50 hover:dark:bg-transparent focus:z-20 focus:outline-offset-0"
        >
          <span class="sr-only">Next</span>
          <svg
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </nav>
    </div>
  </div>
</div>
